/**
 * dots.jsx
 *
 * @Author: bjzhuwei
 * @Date: 2017/8/18 22:52
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * @ignore
 * */
class Dots extends React.PureComponent {
    static propTypes = {
        type: PropTypes.string,
        len: PropTypes.number,
        imgList: PropTypes.array,
        activeIndex: PropTypes.number,
        handleClick: PropTypes.func,
        hover: PropTypes.bool,
    };

    render() {
        const {
            len,
            smallImgList,
            activeIndex,
            imgWidth,
            arrowStyle,
            smallImgWidth,
            handleClick,
            display,
            ...other
        } = this.props;
        let smallImgContainerWidth = len * (smallImgWidth + 2 || 60);
        const imgInnerStyle = {};
        if (smallImgContainerWidth > imgWidth) {
            smallImgContainerWidth = imgWidth;
            imgInnerStyle.overflowY = 'scroll';
        }
        imgInnerStyle.width = `${smallImgContainerWidth}px`;
        return (
            <div className="dots-index-container" style={{ width: `${imgWidth}px` }}>
                {len !== 1 && display ? (
                    <div
                        className={classNames('dots', 'inner-bottom')}
                        ref={e => (this.dots = e)}
                        style={arrowStyle}
                        {...other}>
                        <div className="inner">
                            <div className="dots-list">
                                {smallImgList.map((item, index) => {
                                    const currentIndex = index + 1;
                                    const className =
                                        activeIndex === currentIndex ? 'on dot-item dot-btn' : 'dot-item dot-btn';
                                    return (
                                        <span
                                            key={currentIndex}
                                            className={className}
                                            onClick={() => handleClick(currentIndex)}/>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default Dots;



// WEBPACK FOOTER //
// ./src/carousel/dots.jsx